import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private router: Router, private httpClient: HttpClient) { }

  public getDailyReportValues(date: string)
  {
    return this.httpClient.get(`${environment.apiUrl}/api/report/dailyreport/${date}`) as Observable<any>;
  }
}
